export const LeadStatusEnum = [
    { title: 'New', value: 1 },
    { title: 'Assigned', value: 2 },
    { title: 'In Progress', value: 3 },
    { title: 'Contacted', value: 4 },
    { title: 'Patient Created', value: 5 },
    { title: 'Closed', value: 6 },
]